// extracted by mini-css-extract-plugin
export var title = "title-module--title--1cida";
export var center = "title-module--center--qGK-o";
export var margin = "title-module--margin--wyZ59";
export var black = "title-module--black--1pfOn";
export var sm = "title-module--sm--1CS9W";
export var lg = "title-module--lg--1fOfk";
export var weightMd = "title-module--weightMd--ADL3x";